import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/pages/home'
import Orders from '@/pages/orders'
import OrderListNew from '@/pages/order-list-new'
import Services from '@/pages/services'
import Gift from '@/pages/gift'
import My from '@/pages/my'
// import TestPage from '@/pages/test'
import EnterPage from '@/pages/enter'
// import Missing from '@/pages/missing'

import WechatAuth from 'vue-wechat-auth'
import axios from 'axios'

import _ from 'lodash';

Vue.use(Router)


const ua = navigator.userAgent.toLowerCase() || window.navigator.userAgent.toLowerCase();
const isWX = /MicroMessenger/i.test(ua) && location.protocol === 'https:';
const isAndroid = /Android/i.test(ua);
const isiOS = /iPhone/i.test(ua);


function currentPageUrl() {
  return window.location.href.split('#')[0];
}
//当前ulr encodeURIComponent
function encodeLocalUrl(){
  return window.encodeURIComponent(currentPageUrl())  // url必须动态获取，不能缓存
}

window.landingPageInited = false;
window.landingPage = null;

if (!window.landingPage) {
  window.landingPage = currentPageUrl();
  // alert("当前的 页面登录页 是: " + window.landingPage)
  console.log("当前页面是", window.landingPage);
}

const isBeta = window.isBeta = window.location.pathname.startsWith('/beta');
window.isDev = window.location.hostname === 'localhost';

const baseUrl = isBeta ? '/beta/' : null;

let _wechat = {
  appid: 'wxcaed5d82069229e5',
  isWX: isWX,
  isAndroid: isAndroid,
  isiOS: isiOS,
  env: {
    isBeta: isBeta,
    baseUrl: baseUrl,
    fullBaseUrl: window.location.origin + (isBeta ? '/beta/' : '/')
  },
  useWXCamera: false,//是否允许用微信的流程

  _callbacks: [],//签名回调集合

  config: (data) => {

    if (_.isEmpty(data)) {
      alert("无法进行微信签名");
      return;
    }

    Vue.prototype.$wx.config({
      debug: false,
      appId: data.appId,
      timestamp: data.timestamp,
      nonceStr: data.nonceStr,
      signature: data.signature,
      jsApiList: [
        'checkJsApi',
        'onMenuShareTimeline',//旧的接口，即将废弃
        'onMenuShareAppMessage',//旧的接口，即将废弃
        'onMenuShareQQ',
        'onMenuShareWeibo',
        'chooseWXPay',
        'updateAppMessageShareData',
        'updateTimelineShareData',
        "chooseImage","previewImage","uploadImage","downloadImage"
      ]
    });

    Vue.prototype.$wx.checkJsApi({
      jsApiList: ['chooseImage'], // 需要检测的JS接口列表，所有JS接口列表见附录2,
      success: function(res) {
      // 以键值对的形式返回，可用的api值true，不可用为false
      // 如：{"checkResult":{"chooseImage":true},"errMsg":"checkJsApi:ok"}
      console.log("检查获取图片", res);
      }
  });


    Vue.prototype.$wx.error((res) => {
      console.error(res);
    })
  },
  
  getSignature: (cb) => {

    if (!isAndroid) {//是iOS设备
      console.log("检测到是iOS设备，准备进行签名: ", window.landingPage);
      if (!window.landingPageInited) {
        if (cb) {
          _wechat._callbacks.push(cb);
        }
        // alert("准备签名: " + window.landingPage)
  
        //把当前页面进行签名
        axios.post('/api/wechat/config', {url: window.landingPage})
        .then(response => {
          if (response) {
            
            let data = response.data.data;
            
            _wechat.config(data);
            window.landingPageInited = true;
            
            if (_wechat._callbacks.length > 0) {
              for (let _cb of _wechat._callbacks) {
                _cb();
              }

              _wechat._callbacks = [];//清空
            }
          }
        })

      } else {
        if (cb) {
          cb();
        }
      }
    } else {
      console.log("不是iOS设备，签名实时获取");

      axios.post('/api/wechat/config', {url: currentPageUrl()})
        .then(response => {
          if (response) {
            let data = response.data.data;
            _wechat.config(data);

            if (cb) {
              cb();
            }
          }
        })
    }
    
  }
};

if (isBeta) {
  if (!global.vConsole) {
    const Vconsole = require( 'vconsole');
    global.vConsole = new Vconsole()
  }
}

const router = new Router({
  mode: 'history',
  base: _wechat.env.baseUrl,
  routes: [
    {
      path: '/',
      component: () => (import ('@/pages/tab-container-vant')),
      children: [
        {
          path: '/',
          name: 'home',
          component: Home,
          meta: {
            title: "同城保",
            auth: true
          }
        },
        {
          path: 'my',
          name: 'my',
          component: My,
          meta: {
            title: "我的",
            auth: true
            ,authPage: true
          }
        },
        {
          path: 'orders',
          name: 'orders',
          component: Orders,
          meta: {
            title: "我的订单",
            auth: true
            ,authPage: true
          }
        },
        // {
        //   path: 'order/list',
        //   name: 'order-list',
        //   component: OrderList,
        //   meta: {
        //     title: "代缴服务",
        //     auth: true
        //     ,authPage: true
        //   }
        // },
        {
          path: 'order/list',
          name: 'order-list',
          component: OrderListNew,
          meta: {
            title: "代缴服务",
            auth: true
            ,authPage: true
          }
        },
        // {
        //   path: 'gift',
        //   name: 'gift',
        //   redirect:  to => {return '/'} 
        // },
       
        {
          path: 'services',
          name: 'services',
          component: Services,
          meta: {
            title: "服务大厅",
            auth: true
            ,authPage: true
          }
        },
        {
          path: 'home',
          redirect: '/'
        }
      ]
    },
    {
      path: '/enter',
      name: 'enter',
      component: EnterPage,
      meta: {
        title: "进入"
      }
    },
    {
      path: '/login',
      name: 'login',
      component: () => import ('@/pages/login'),
      meta: {
        title: "手机号登录用户"
      }
    },
    
    {
      path: '/missing',
      name: 'missing',
      component: () => import ('@/pages/missing'),
      meta: {
        title: "页面缺失"
      }
    },

    {
      path: '/gift',
      name: 'gift',
      component: Gift,
      meta: {
        title: "约惠接力",
        auth: true
        ,authPage: true
      },
    },

    {
      path: '/how',
      name: '/how',
      component: () => import ('@/pages/how'),
      meta: {
        title: "办理流程",
        resetPosition: true
      }
    },
    {
      path: '/service/:type',
      name: 'service',
      component: () => import ('@/pages/service'),
      meta: {
        title: "服务介绍",
        resetPosition: true,
        auth: true
        ,authPage: true
      }
    },
    {
      path: '/service-orders/:state',
      name: 'service-orders',
      component: () => import ('@/pages/service-orders'),
      meta: {
        title: "服务订单",
        resetPosition: true,
        auth: true
        ,authPage: true
      }
    },
    {
      path: '/service-detail/:orderno',
      name: 'service-detail',
      component: () => import ('@/pages/service-detail'),
      meta: {
        title: "服务详情",
        resetPosition: true,
        auth: true
        ,authPage: true
      }
    },
    // ==================== v2 urls ==========
    {
      path: '/order/new',
      name: 'order-new',
      component: () => import('@/pages/order-confirm'),
      meta: {
        title: '缴纳基本信息',
        resetPosition: true,
        auth: true,
        authPage: false
      }
    },
    {
      path: '/order/confirm',
      name: 'order-confirm',
      component: () => import('@/pages/order-confirm'),
      meta: {
        title: '缴纳基本信息',
        resetPosition: true,
        auth: true,
        authPage: false
      }
    },
    {
      path: '/order/detail/:orderno',
      name: 'order-detail',
      component: () => import ('@/pages/order-detail'),
      meta: {
        title: "订单详情",
        resetPosition: true,
        auth: true
        ,authPage: true
      }
    },
    {
      path: '/order/pay',
      name: 'order-pay',
      component: () => import('@/pages/order-pay'),
      meta: {
        title: '付款',
        resetPosition: true,
        auth: true,
        authPage: false
      }
    },
    {
      path: '/order/detail/:orderno/progress',
      name: 'order-progress',
      component: () => import('@/pages/order-progress'),
      meta: {
        title: '办理进展',
        resetPosition: true,
        auth: true,
        authPage: false
      }
    },
    {
      path: '/coupons',
      name: 'coupons',
      component: () => import('@/pages/coupons'),
      meta: {
        title: '缴纳基本信息',
        resetPosition: true,
        auth: true,
        authPage: false
      }
    },
    {
      path: '/coupon/offer/:code',
      name: 'coupon-share',
      component: () => import('@/pages/coupon-offer'),
      meta: {
        title: '优惠券赠送',
        resetPosition: true,
        auth: true,
        authPage: false
      }
    },
    {
      path: '/service-rate/:userid',
      name: 'service-rate',
      component: () => import ('@/pages/service-rate'),
      meta: {
        title: "服务详情",
        resetPosition: true,
        auth: true
        ,authPage: true
      }
    },
    {
      path: '/profile-append/:orderno',
      name: 'profile-append',
      component: () => import('@/pages/profile-append'),
      meta: {
        title: '补充资料',
        resetPosition: true,
        auth: true,
        authPage: true
      }
    },

    {
      path: '/calculator',
      name: 'calculator',
      component: () => import ('@/pages/calculator'),
      meta: {
        title: "计算器",
        resetPosition: true
      }
    },
    {
      path: '/calculator-cbj',
      name: 'calculator-cbj',
      component: () => import ('@/pages/calculator-cbj'),
      meta: {
        title: "残保金计算器",
        resetPosition: true
      }
    },
    {
      path: '/calculator-tax',
      name: 'calculator-tax',
      component: () => import ('@/pages/calculator-tax'),
      meta: {
        title: "个税计算器",
        resetPosition: true
      }
    },

    
    {
      path: '/reset',
      name: 'reset',
      component: () => import ('@/pages/reset'),
      meta: {
        title: "修改密码",
        resetPosition: true
      }
    },

    {
      path: '/bind',
      name: 'bind',
      component: () => import ('@/pages/bind'),
      meta: {
        title: "绑定/更新手机",
        resetPosition: true,
        auth: true,
        authPage: true
      }
    },

    {
      path: '/about',
      name: 'about',
      component: () => import ('@/pages/about'),
      meta: {
        title: "关于我们",
        resetPosition: true
      }
    },
    {
      path: '/con',
      name: 'con',
      component: () => import ('@/pages/contact'),
      meta: {
        title: "联系我们",
        resetPosition: true
      }
    },
    {
      path: '/register-contract',
      name: 'register-contract',
      component: () => import ('@/pages/register-contract'),
      meta: {
        title: "注册协议  ",
        resetPosition: true
      }
    },
    {
      path: '/read',
      name: 'read',
      component: () => import ('@/pages/read'),
      meta: {
        title: "购买须知",
        resetPosition: true
      }
    },
    {
      path: '/vip-read',
      name: 'vip-read',
      component: () => import ('@/pages/vip-read'),
      meta: {
        title: "同城保VIP一次性会员费使用须知",
        resetPosition: true
      }
    },
    {
      path: '/agree-agreement',
      name: 'agree-agreement',
      component: () => import ('@/pages/agree-agreement'),
      meta: {
        title: "同城保VIP一次性会员费使用须知",
        resetPosition: true
      }
    },
    // {
    //   path: '/share/:uid',
    //   name: 'share',
    //   redirect:  to => {return '/'} 
    // },
    {
      path: '/withdraw',
      name: 'withdraw',
      redirect:  to => {return '/'} 
    },
    {
      path: '/gift-status',
      name: 'gift-status',
      component: () => import ('@/pages/gift-status'),
      meta: {
        title: "分享记录",
        resetPosition: true
      }
    },
    {
      path: '/share/:uid',
      name: 'share',
      component: () => import ('@/pages/share'),
      meta: {
        title: "来同城保约惠啦",
        resetPosition: true
      }
    },
    {
      path: '/withdraw',
      name: 'withdraw',
      component: () => import ('@/pages/gift-withdraw'),
      meta: {
        title: "同城保约惠接力",
        resetPosition: true
      }
    },
    {
      path: '/gift-status',
      name: 'gift-status',
      component: () => import ('@/pages/gift-status'),
      meta: {
        title: "分享进展",
        auth: true,
        authPage: true
      }
    },
    {
      path: '/balance/:balanceid',
      name: 'balance',
      component: () => import ('@/pages/balance'),
      meta: {
        title: "差额单详情",
        auth: true,
        authPage: true
      }
    },
    
    {
      path: '*',
      redirect: '/missing'
    }
  ],
  // https://router.vuejs.org/zh-cn/advanced/scroll-behavior.html
  scrollBehavior(to, from, savedPosition) {
    if (to.meta && to.meta.resetPosition) {
      return {x: 0, y: 0};
    }
  }
});



Vue.prototype.$wechat = _wechat;
router.loadedCallback = (vm) => {

  // if (_wechat.isWX) {
  //   _wechat.getSignature();
  // }

  let store = vm.$store;

  router.beforeEach((to, _from, next) => {
    if (to.meta && to.meta.title) {
      document.title = to.meta.title;
    }
  
    // console.log("准备跳转", to);
    // 路由发生变化时，修改页面title
    if (to.meta && to.meta.authPage) {
      if (!_.isEmpty(store.state.user)) {
        next();
      } else {
        next({
          path: '/enter',
          query: {redirect: to.fullPath}
        })
      }
    } else {
      next();
    }
    // next();
  })
  
  
  // const useWechatAuth = isWX;//是否是微信
  const useWechatAuth = isWX;//是否是微信
  
  if (useWechatAuth) {
    //清理
  
    let oldAt = window.localStorage.getItem("access_token")
    let openid = store.state.openid;
    let openid_at = store.state.openid_at;
  
    let refreshToken = true;
    if (!_.isEmpty(oldAt) && _.isEmpty(openid)) {//有access token 但是没有Openid
      window.localStorage.removeItem("access_token");//清理掉
    } else if (!_.isEmpty(oldAt) && !_.isEmpty(openid)) {//两个都存在
      // if (openid_at && openid_at > 0 && 
      //     (Date.now() - openid_at) < 1000 * 60 * 60 * 24) {//如果上次刷新小于1天
      //   refreshToken = false;
      // }
    }
  
    // console.log("是微信客户端，准备用这个流程");
    if (refreshToken) {
      Vue.use(WechatAuth, {
        router, // 路由实例对象
        appid: Vue.prototype.$wechat.appid, // 您的微信appid
        responseType: 'code',  // 返回类型，请填写code
        scope: 'snsapi_userinfo', // 应用授权作用域，snsapi_base （不弹出授权页面，直接跳转，只能获取用户openid），snsapi_userinfo （弹出授权页面，可通过openid拿到昵称、性别、所在地。并且，即使在未关注的情况下，只要用户授权，也能获取其信息）
        getCodeCallback (code, next) {
          // 用户同意授权后回调方法
          // code：用户同意授权后，获得code值
          // code说明： code作为换取access_token的票据，每次用户授权带上的code将不一样，code只能使用一次，5分钟未被使用自动过期。
          // next： 无论access_token是否获取成功,一定要调用该方法
          // next说明：next方法接收两个参数
          // { "access_token":"ACCESS_TOKEN",
          // "expires_in":7200,
          // "refresh_token":"REFRESH_TOKEN",
          // "openid":"OPENID",
          // "scope":"SCOPE" }
          // 参数1为通过code值请求后端获取到的access_token值，如果获取失败请填入空字符串''
          // 参数2(非必填，默认获取access_token切换到当前路由对象)，指定切换对象 next('/') 或者 next({ path: '/' })
          // let tokenUrl = https://api.weixin.qq.com/sns/oauth2/access_token?appid=${wechatConfig.appid}&secret=${wechatConfig.secret}&code=${code.trim()}&grant_type=authorization_code;
          axios.get('/api/wechat/auth', {
            params: {
              code,
              state: ''//这里可以用于追溯从哪里来的，比如说分享的id
            }
          }).then((response) => {
            let data = response.data
            console.log("登录后的响应是", data);
      //       { access_token: '***-_g7f2fJCF7VZ_dejdSbC9be71c-P6eA',
      // expires_in: 7200,
      // refresh_token: '8_pSwwoPR60xZBg5kp-7uI0ESUFcSF6MvUXCPDtfX9sB5yJ5l1wt3slbhwIwFQ4aZa-I7rU57T0x75T0Ax4clUdA',
      // openid: 'ogwhVwa5p6sXkzol1YzmvbTO**',
      // scope: 'snsapi_userinfo' }
            let accessToken = data.data['access_token'];
            let newOpenid = data.data['openid'];
            // console.log("准备持久化openid", openid);
            if (!_.isEmpty(newOpenid)) {
              if (newOpenid !== openid) {
                store.commit('openid', newOpenid);//保存openid信息
              }
              
              axios.post("/api/user/tryWechatLogin", {openid: newOpenid}).then(res => {
                if (res) {
                  store.commit("login", res.data.data);
                }
              })
            }
    
    
            if (accessToken) {
              next(accessToken) // 获取access_toeken成功
            } else {
              next() // 获取access_token失败
            }
            
            // let userUrl = "https://api.weixin.qq.com/sns/userinfo?access_token="+accessToken+"&openid="+openid+"&lang=zh_CN";
    
          }).catch((err) => {
            console.error("获取access token 出错", err);
            next() // ajax出现错误
          })
        }
      })
    }
  
  
  }

}



export default router



// WEBPACK FOOTER //
// ./src/router/index.js